import React, { useState, useRef } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useClickOutside } from '../../hooks/useClickOutside';
interface DropdownProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  align?: 'left' | 'right';
  width?: string;
  onOpen?: (rect: DOMRect) => void;
}
export const Dropdown = ({
  trigger,
  children,
  align = 'left',
  width = 'w-48',
  onOpen
}: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(dropdownRef, () => setIsOpen(false));
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    const nextState = !isOpen;
    setIsOpen(nextState);
    if (nextState && onOpen && dropdownRef.current) {
      // Small delay to allow the dropdown to render and get its true height
      setTimeout(() => {
        if (dropdownRef.current) {
          onOpen(dropdownRef.current.getBoundingClientRect());
        }
      }, 0);
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-105">
      <div onClick={handleToggle} data-id="element-106">{trigger}</div>
      {isOpen && <div className={`
            absolute 
            z-50 
            mt-2 
            ${width}
            bg-[#1a1a1a] 
            border 
            border-[#444444] 
            rounded-lg 
            shadow-lg 
            overflow-hidden
            ${align === 'right' ? 'right-0' : 'left-0'}
            animate-fade-in
          `} data-id="element-107">
          {children}
        </div>}
    </div>;
};